module.exports = __webpack_public_path__ + "img/ymyc6.f66a84bb.jpg";